// import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

export const StyledChainScanTokenLink = styled.div`
  margin-left: 5px;

  & img {
    cursor: pointer;
  }

  & a {
    cursor: pointer;
  }
`;
